import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// StrictMode is disabled to prevent double-rendering and duplicate API calls during development.
// StrictMode has no effect in production builds anyway - React automatically optimizes it out.
// If you need StrictMode for development testing, set REACT_APP_STRICT_MODE=true
const enableStrictMode = process.env.REACT_APP_STRICT_MODE === 'true';

root.render(
  enableStrictMode ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
